import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { useReplies } from '../../_load/ServiceOrderLoader'
import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'

const AnexoBContent = () => {
  const replies = useReplies()
  const communicationNumber = getReplyValue(findReplyByQuestionId(replies, 253))
  const importer = getReplyValue(findReplyByQuestionId(replies, 257))
  const importerAddress = getReplyValue(findReplyByQuestionId(replies, 254))
  const cnpj = getReplyValue(findReplyByQuestionId(replies, 259))
  const purpose = getReplyValue(findReplyByQuestionId(replies, 255))
  const importerEmail = getReplyValue(findReplyByQuestionId(replies, 256))

  return (
    <View pageBreakAfter>
      <Text bold align="center" size="h5">
        ANEXO B
      </Text>
      <Text bold align="center" size="h5">
        COMUNICAÇÃO PRÉVIA DE IMPORTAÇÃO
      </Text>
      <Separator weight={5} />
      <Text bold>Comunicação Prévia nº {communicationNumber}</Text>
      <Separator weight={5} />
      <Text bold>
        <u>1ª PARTE:</u> INTERESSADO
      </Text>
      <Text>
        Sr Diretor de Fiscalização de Produtos Controlados <br />
        {importer}, estabelecida na {importerAddress.search} – CNPJ: {cnpj}, representada neste ato pelo
        XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX, vem respeitosamente comunicar a intenção de importar dos Estados Unidos o
        material da discriminação dos items 1 (verso), do tipo 4. Menos-letal, Grupo 4.2 - Munições, nº de Ordem
        4.2.0020 - Munição/Cartucho de Dardos Energizados.
      </Text>
      <Separator weight={5} />
      <Text bold>DADOS COMPLEMENTARES</Text>
      <Text>
        a. Nº de Registro no SIGMA e respectiva validade: <b>Isento.</b>
      </Text>
      <Text>
        b. Local de destino (endereço do depósito): <b>{importerAddress.search}</b>
      </Text>
      <Text>
        c. Finalidade da importação: <b>{purpose}</b>
      </Text>
      <Text>
        d. Regime de importação: <b>Definitivo.</b>
      </Text>
      <Text>
        e. Outros dados que julgar necessários: <b>{importerEmail}</b>
      </Text>
      <Separator weight={5} />
      <Text>
        2. O desembaraço alfandegário e a obtenção de visto na "GUIA DE TRÁFEGO", pelo (a) requerente, deverá ser feito
        junto ao seguinte SFPC/Regional: <b>SFPC/2ºRM.</b>
      </Text>
      <Separator weight={5} />
      <Text>
        3. O registro de entrada será feito na Unidade Fiscalizadora da Secretaria de Estado da Segurança Pública do
        Paraná, em Curitiba/PR.
      </Text>
      <Separator weight={5} />
      <Text>5. Outros:</Text>
      <Text>
        (x) Estou ciente que as informações deste processo serão remetidas para o e-mail fornecido neste requerimento e
        me responsabilizo pela disponibilidade do mesmo para recebimento de mensagens.
      </Text>
      <Text>
        (x) *Necessito a emissão do CII (Certificado Internacional de Importação) impresso por exigência do país
        exportador.
      </Text>
      <Text>
        ( ) *Necessito a emissão do CUF(certificado de Usuário Final- "EndUser") por exigência do país exportador.
      </Text>
      <Text>
        * Processos em que seja solicitado o CII impresso ou do CUF não serão remetidos via e-mail para o importador,
        devendo aguardar a remessa via correios.
      </Text>
      <Text>
        * Caso o PCE esteja enquadrado como PRODE e o importador seja pessoa jurídica, a competência para emissão de CII
        e CUF é do Ministério da Defesa.
      </Text>
      <Separator weight={5} />
      <Text>
        6. É a <b>primeira</b> vez que requer.
      </Text>
      <Separator weight={15} />
      <Text align="right">_______________________________________________________</Text>
      <Separator weight={20} />
      <Text>
        <b>
          <u>2ª PARTE: COTER</u>
        </b>
        - Encaminhamento e Parecer (se PM ou CBM) nº _________________________________________________________________
        <br />
        ________________________________________________________________________________________________________________________________________
      </Text>
      <Text>
        (Local e data) _____________________________________, _______/_______/________ -
        _________________________________________________________
      </Text>
      <Text align="right" style={{ paddingRight: '50px' }}>
        (COTER -Oficial encarregado - Carimbo)
      </Text>
      <Text>- Observações</Text>
      <Text size="small">
        1. Quando a lista de material ou discriminação das mercadorias for extensa, elaborar outros Certificados ou
        anexar uma relação em Folha Suplementar (continuação).
      </Text>
      <Text size="small">
        2. No regime de importação temporário, terminado o evento que motivou a importação, o material deverá retornar
        ao seu país de origem.
      </Text>
      <Text size="small">3. No caso de armas de fogo, munições e acessórios, deverão ser informadas as</Text>
      <Text>
        características específicas dos produtos, conforme estabelece o Decreto nº 9847, de 25 de junho de 2019.
      </Text>
      <Text size="small">
        4. No caso da importação de armas, deverão ser remetidas à DFPC as informações das armas para cadastro no
        SICOFA.
      </Text>
      <Text size="small">5. Anexar a tabela de dotação com efetivos de pessoal e material, existente e previsto.</Text>
      <Text>
        6. O produto coberto por este documento deverá ser objeto de um único embarque e de uma única Licença de
        Importação.
      </Text>
      <Text size="small">
        7. Os dados contidos no campo "outros dados que julgar necessários" não poderão conter informação discrepante
        com a prestada em campos específicos, sob pena de invalidar a autorização emitida.
      </Text>
      <Text size="small">8. Endereço da DFPC: QGEx, Bloco H, 4º Andar – SMU – 70.630-901 – Brasília/DF.</Text>
    </View>
  )
}

export default AnexoBContent
